import { Dialog, DialogContent, Divider } from "@mui/material";
import React from "react";
import ViewReverse from "./ViewReverse";
import icons from "../constants/icons";
import { ReactSVG } from "react-svg";
import Text from "./Text";
import { fontSizes } from "../constants/constants";

const CustomModal = ({ isOpen, onClose, isFullWidth, heading, maxWidth, children, isHeader = true, isCenter }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth={isFullWidth}
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          position: "absolute",
          top:!isCenter && 10,
        },
      }}
    >
      <DialogContent sx={{ paddingTop: 3, paddingBottom: 2 }}>
        {
          isHeader && (
            <>
              <ViewReverse className={"items-center justify-between"}>
                <Text text={heading} size={fontSizes.h22} />
                <ReactSVG
                  src={icons.modalCross}
                  className="cursor-pointer"
                  onClick={onClose}
                />
              </ViewReverse>
              <Divider />
            </>
          )
        }
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
